import { FieldError } from './types'

export const isFieldErrorObject = (error: unknown): error is FieldError => {
  return (
    typeof error === 'object' &&
    error !== null &&
    'cvid' in error &&
    'field_id' in error &&
    'cell_value' in error
  )
}
